import { fetchResource } from '@/services/fetchService.js'

const isStaging = process.env.NODE_ENV === 'staging'
const api = isStaging ? '/api-staging' : '/api'

class TenantService {
  constructor() {
    this.type = ''
  }

  fetchTenant = async (tenantKey) => {
    const tenant = await fetchResource(tenantKey)
    return tenant
  }

  fetchTenants = async () => {
    try {
      const response = await fetch(`${api}/tenants`)
      if (response.ok) {
        return response.json()
      } else {
        throw new Error(response.statusText)
      }
    } catch (error) {
      console.error('[tenantService]:', error)
      throw error
    }
  }
}

export default TenantService
export const tenantService = new TenantService()
